export default __webpack_public_path__ + "static/media/volumerender.67bc9e9d.frag";